import { useEffect } from "react";
import { useRenderPhaseCallback } from "./use-render-phase-callback";

export const useWindowNativeEventListener = <EventName extends keyof WindowEventMap>(
	ctxWindow: Window,
	name: EventName | undefined,
	listener: (event: WindowEventMap[EventName]) => void,
	options?: boolean | AddEventListenerOptions,
) => {
	const renderPhaseListener = useRenderPhaseCallback(listener);

	useEffect(() => {
		if (!name) return;

		const handler = (event: WindowEventMap[EventName]) => {
			renderPhaseListener(event);
		};
		ctxWindow.addEventListener(name, handler, options);
		return () => {
			ctxWindow.removeEventListener(name, handler, options);
		};
	}, [ctxWindow, name]);
};
